// src/App.js
import React, { Suspense, lazy, useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './Header';
import { initializeAnalytics, trackPageView } from './analytics';
import './App.css';

const BlogListPage = lazy(() => import('./Blog/BlogListPage'));
const BlogPostPage = lazy(() => import('./Blog/BlogPostPage'));

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initializeAnalytics();
  }, []);

  useEffect(() => {
    const pagePath = `${location.pathname}${location.search}${location.hash}`;
    trackPageView(pagePath);
  }, [location]);

  return null;
}

function App() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const savedTheme = window.localStorage.getItem('preferred-theme');
    if (savedTheme === 'light' || savedTheme === 'dark') {
      setTheme(savedTheme);
      return;
    }
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setTheme('dark');
    }
  }, []);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    document.documentElement.setAttribute('data-theme', theme);
    document.body.classList.toggle('dark-mode', theme === 'dark');
    document.body.classList.toggle('light-mode', theme === 'light');
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('preferred-theme', theme);
    }
  }, [theme]);

  const handleToggleTheme = () => {
    setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
  };

  const containerClassName = `container ${theme === 'dark' ? 'theme-dark' : 'theme-light'}`;

  return (
    <Router>
      <AnalyticsTracker />
      <div className={containerClassName}>
        <Header theme={theme} onToggleTheme={handleToggleTheme} />
        <Suspense fallback={<div className="route-loading">ページを読み込み中...</div>}>
          <Routes>
            <Route path="/" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} /> 
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
